// import React, { useEffect, useState } from "react";
// import Form from "react-bootstrap/Form";
// import { Link } from "react-router-dom";
// import Col from "react-bootstrap/Col";

// import Row from "react-bootstrap/Row";

// import { useContext } from "react";
// import { Context } from "../../../../utils/context";
// function Step1({ handleNext }) {
//   const {
//     postData,
//     jobSeekerData,
//     setJobSeekerData,

//     getJobSeekerData,
//   } = useContext(Context);

//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     step: 2,
//     status: true,
//   });

//   const [first_name, setFirstName] = useState("");

//   const [last_name, setLastName] = useState("");

//   const [nameErr, setNameErr] = useState("");
//   const [lastNameErr, setlastNameErr] = useState("");

//   const handleValidation = async () => {

//     // Initialize an array to store error messages
//     var errors = [];

//     if (!formData?.first_name) {
//       setNameErr("First Name is required");
//       errors.push("First Name is required");
//     }

//     if (!formData?.last_name) {
//       setlastNameErr("Last Name is required");
//       errors.push("Last Name is required");
//     }

//     if (errors.length === 0) {

//       const data = {
//         first_name: first_name,
//         last_name: last_name,
//         step: 2,
//         status: true,
//       };
//       const res = await postData(`/jobseeker/signup/name`, formData);
//       if (res?.success) {
//         handleNext();
//       } else {

//       }
//     }
//   };

//   const seekerData = async () => {
//     const res = await getJobSeekerData();
//     if (res?.first_name != null && res?.last_name != null) {
//       await setFormData({
//         first_name: res?.first_name,
//         last_name: res?.last_name,
//         step: 2,
//         status: "none",
//       });
//     }
//   };

//   const handleChange = async (e) => {

//     setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
//   };
//   useEffect(() => {
//     seekerData();
//   }, []);
//   return (
//     <>
//       <fieldset>
//         <div className="form-card StepForm">
//           <div className="row step1_nameField mt-4">
//             <div className="d-flex  steps-heading">
//               <div className="border-left" />
//               <h5>Step 1</h5>
//             </div>
//             <Form>
//               <Row>
//                 <div className="col-md-6 col-sm-12 mb-3">
//                   <Form.Label>
//                     First Name <span className="text-danger">*</span>{" "}
//                   </Form.Label>
//                   <Form.Control
//                     name="first_name"
//                     type="text"
//                     placeholder="Enter First Name"
//                     defaultValue={formData?.first_name}
//                     onKeyDown={(event) => {
//                       const allowedCharacters = /[A-Za-z ]/;
//                       if (!allowedCharacters.test(event.key)) {
//                         event.preventDefault();
//                       }
//                     }}
//                     onKeyUp={(event) => {
//                       handleChange(event);
//                       setNameErr("");
//                     }}
//                   />
//                   <span
//                     className="text text-danger "
//                     style={{
//                       textAlign: "center",
//                     }}
//                   >
//                     {nameErr && nameErr}
//                   </span>
//                 </div>

//                 <div className="col-md-6 col-sm-12 mb-3">
//                   <Form.Label>
//                     Last Name <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     name="last_name"
//                     type="text"
//                     placeholder="Enter Last Name"
//                     defaultValue={formData?.last_name}
//                     onKeyDown={(event) => {
//                       if (!/[A-Z-a-z ]/.test(event.key)) {
//                         event.preventDefault();
//                       }
//                     }}
//                     onKeyUp={(event) => {
//                       handleChange(event);
//                       setlastNameErr("");
//                     }}
//                   />
//                   <span
//                     className="text text-danger "
//                     style={{
//                       textAlign: "center",
//                     }}
//                   >
//                     {lastNameErr && lastNameErr}
//                   </span>
//                 </div>
//               </Row>
//             </Form>
//             <div className="mobile-view-button">
//               <button
//                 type="button"
//                 name="next"
//                 className="next action-button contin-btn"
//                 onClick={handleValidation}
//               >
//                 Continue
//               </button>
//             </div>
//           </div>
//         </div>
//       </fieldset>

//       <div className="row mt-5  pt-4 footer-sec">
//         <div className="col-md-10 col-12 desktop-view-button">
//           {/* <div className="check-row text-start">
//             <span>
//               <Form.Check inline name="group1" className="me-2" />
//             </span>
//             <span className=" by-text ">By signing up, I agree to the</span>
//             <span className="px-1 ">
//               <Link to="/terms" className="term-btn">
//                 Term and Conditions
//               </Link>
//             </span>
//             <br />
//           </div>
//           <div className="login-row text-start">
//             <span className="">Already an User?</span>
//             <span className="px-1 ">
//               <Link to="/other-page" className="login-btn">
//                 log In
//               </Link>
//             </span>
//             &nbsp; &nbsp; &nbsp;
//             <span className="">Not a Jobseeker?</span>
//             <span className="px-1 ">
//               <Link to="/signup-recruiter" className="signup-btn">
//                 Signup as Recruiter
//               </Link>
//             </span>
//           </div> */}
//         </div>
//         {/* <div className="col-md-8 col-12 mb-5  mobile-view-button">
//           <div className="check-row text-start">
//             <span>
//               <Form.Check inline name="group1" className="me-2" />
//             </span>
//             <span className=" by-text ">By signing up, I agree to the</span>
//             <span className="px-1 ">
//               <Link to="/terms" className="term-btn">
//                 Term and Conditions
//               </Link>
//             </span>
//             <br />
//           </div>
//           <div className="login-row text-start">
//             <span className="">Already an User?</span>
//             <span className="px-1 ">
//               <Link to="/other-page" className="login-btn">
//                 log In
//               </Link>
//             </span>
//             <br />
//             <span className="">Not a Jobseeker?</span>
//             <span className="px-1 ">
//               <Link to="/signup-recruiter" className="signup-btn">
//                 Signup as Recruiter
//               </Link>
//             </span>
//           </div>
//         </div> */}

//         <div className="col-2">
//           <div className="desktop-view-button">
//             <button
//               type="button"
//               name="next"
//               className="next action-button contin-btn"
//               onClick={handleValidation}
//             >
//               Continue
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Step1;

import React, { useEffect, useState, useContext } from "react";
import { Form, Row, Modal, Col } from "react-bootstrap";
import Select from "react-select";
import { Context } from "../../../../utils/context";
import Lottie from "react-lottie";
import * as animationData from "./Completedlotty.json";
import * as animationDataTwo from "./Hundredper.json";
import { getData } from "../../../../utils/api";
import { useNavigate } from "react-router-dom";
import Autosuggest from "react-autosuggest";

function Step1({ handleNext }) {
  const navigate = useNavigate();
  const { postData, getJobSeekerData } = useContext(Context);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    // dob: "",
    email: "",
    contact_no: "",
    // living_city_id: null,
    // nationality_id: null,
    university: "",
    degree: "",
    cgpa_or_grade: "",
    specialization_id: null,
    specialization: "",
    start_date: "",
    end_date: "",

    certificate_file: null,
    resume_file: null,
    status: true,
    // skills: [],
    c_skills: [],
    // jobtypes: [],
    university_id: "",
    degree_id: "",

    //certificate
    certificate: "",
    certificate_for_id: null,
    issuing_org: "",
    c_main_topics: "",
    c_start_date: "",
    c_end_date: "",
    certificatachievement_ide_for_id: null,
  });

  console.log(formData, "formData");

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
    // fontSize: "11px",
  };

  const [otherDegree, setOtherDegree] = useState(false);

  const [otherUniversity, setOtherUniversity] = useState(false);

  const [suggestionsList, setSuggestionsList] = useState([]);

  const getSuggestions = async (inputValue, list) => {
    const inputValueLowerCase = (inputValue || "")?.trim()?.toLowerCase();

    if (!inputValueLowerCase) return [];

    try {
      if (list === "university") {
        const res = await getData(
          `/without-login/master/all-university?name=${inputValueLowerCase}`,
        );

        if (res?.success) {
          setOtherUniversity(res.data.length === 0);

          return res.data.filter((suggestion) =>
            suggestion?.name?.toLowerCase().includes(inputValueLowerCase),
          );
        }
      }

      if (list === "degree") {
        const res = await getData(
          `/without-login/master/all-degree?name=${inputValueLowerCase}`,
        );

        if (res?.success) {
          setOtherDegree(res.data.length === 0);

          return res.data.filter((suggestion) =>
            suggestion?.name?.toLowerCase().includes(inputValueLowerCase),
          );
        }
      }
    } catch (err) {
      console.error(err);
    }

    return [];
  };

  const onSuggestionsFetchRequested = async ({ value }, list) => {
    const suggestions = await getSuggestions(value || "", list);
    setSuggestionsList(suggestions || []);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestionsList([]);
  };

  const onChange = (event, { newValue }) => {
    if (event.target.id === "university_id") {
      const isExistingUniversity = suggestionsList.some(
        (suggestion) => suggestion.name === newValue,
      );
      if (!isExistingUniversity) {
        setFormData((prevData) => ({
          ...prevData,
          university_id: newValue,
          showCollegeInput: true,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          university_id: newValue,
          showCollegeInput: false,
        }));
      }
      // setFormData((prevData) => ({ ...prevData, university_id: newValue }));
    }

    if (event.target.id === "degree_id") {
      const isExistingUniversity = suggestionsList.some(
        (suggestion) => suggestion.name === newValue,
      );
      if (!isExistingUniversity) {
        setFormData((prevData) => ({
          ...prevData,
          degree_id: newValue,
          showDegreeInput: true,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          degree_id: newValue,
          showDegreeInput: false,
        }));
      }
      // setFormData((prevData) => ({ ...prevData, degree_id: newValue }));
    }
  };

  const getSuggestionValue = (suggestion) => suggestion?.name ?? "";

  const renderSuggestion = (suggestion) => (
    <div
      style={{
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "5px",
        margin: "5px",
        backgroundColor: "#f9f9f9",
      }}>
      {suggestion?.name}
    </div>
  );

  const inputProps = {
    onChange,
    style: {
      width: "100%", // Adjust the width as needed
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      // Add other styles as needed
    },
  };

  console.log(formData, "formData");

  const [errors, setErrors] = useState({});
  const [cities, setCities] = useState([]);
  const [nations, setNations] = useState([]);
  const [specialization, setSpecialization] = useState([]);

  console.log(errors, "errors");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [currentAnimation, setCurrentAnimation] = useState(1);

  const handleFirstAnimationFinish = () => {
    // Triggered when the first animation completes
    setCurrentAnimation(2); // Switch to the second animation
  };

  const handleCloseSecondAnimation = () => {
    // Add any logic you need when the second animation is closed
    // For example, you might want to proceed to the next step
    // handleNext();

    console.log("complete");
  };

  const defaultOptionsTwo = {
    loop: false, // Disable loop for the first animation
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const defaultOptionsThree = {
    loop: true, // Enable loop for the second animation
    autoplay: true,
    animationData: animationDataTwo,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  /* ================= FETCH DATA ================= */
  const [specializations, setSpecializations] = useState([]);
  const [skills, setSkills] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [certificateFor, setCertificateFor] = useState([]);
  const [certificateAchievement, setCertificateAchievement] = useState([]);

  const fetchDropdowns = async () => {
    const cityRes = await getData("/without-login/master/all-cities");
    const nationRes = await getData("/without-login/master/all-nationality");
    const specRes = await getData("/without-login/master/all-descipline");
    const skillsRes = await getData("/without-login/master/all-skills");
    const JobTypeRes = await getData("/without-login/master/all-job-type");
    const certificateForRes = await getData(
      "/without-login/master/all-certificate-for",
    );
    const achievementRes = await getData(
      "/without-login/master/all-achievemente",
    );

    if (cityRes?.success) {
      setCities(
        cityRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }

    if (nationRes?.success) {
      setNations(
        nationRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }

    if (specRes?.success) {
      setSpecializations(
        specRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }

    if (skillsRes?.success) {
      setSkills(
        skillsRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }
    if (JobTypeRes?.success) {
      setJobType(
        JobTypeRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }

    if (certificateForRes?.success) {
      setCertificateFor(
        certificateForRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }

    if (achievementRes?.success) {
      setCertificateAchievement(
        achievementRes.data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
    }
  };

  useEffect(() => {
    fetchInitialData();
    fetchDropdowns();
  }, []);

  const fetchInitialData = async () => {
    const seeker = await getJobSeekerData();
    console.log(seeker, "seeker");

    if (seeker) {
      setFormData((prev) => ({
        ...prev,
        first_name: seeker?.first_name || "",
        last_name: seeker?.last_name || "",
        email: seeker?.email || "",
        contact_no: seeker?.contact_no || "",
        gender: seeker?.users_detail?.gender || "",
        // dob: seeker?.users_detail?.dob || "",
      }));
    }
  };

  /* ================= HANDLE CHANGE ================= */

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let error = "";

    if (name === "end_date") {
      const year = Number(value);
      const currentYear = new Date().getFullYear();

      if (value.length > 4) {
        return;
      }

      if (value && (year < 1900 || year > currentYear)) {
        error = `Year must be between 1900 and ${currentYear}`;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleSelectChange = (selected, action) => {
    setFormData((prev) => ({
      ...prev,
      [action.name]: selected,
    }));

    setErrors((prev) => ({ ...prev, [action.name]: "" }));
  };

  const [pdfPreview, setPdfPreview] = useState({
    certificate_file: null,
    resume_file: null,
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const { name } = e.target;

    if (file && file.type !== "application/pdf") {
      setErrors((prev) => ({
        ...prev,
        [name]: "Only PDF files are allowed",
      }));

      setPdfPreview((prev) => ({
        ...prev,
        [name]: null,
      }));

      return;
    }

    if (file) {
      const previewURL = URL.createObjectURL(file);

      setPdfPreview((prev) => ({
        ...prev,
        [name]: previewURL,
      }));
    }

    setFormData((prev) => ({
      ...prev,
      [name]: file,
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  /* ================= VALIDATION ================= */

  const validate = () => {
    let newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const cgpaRegex = /^[0-9]+(\.[0-9]{1,2})?$/;

    if (!formData.first_name) newErrors.first_name = "First name is required";
    if (!formData.last_name) newErrors.last_name = "Last name is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    // if (!formData.dob) newErrors.dob = "Date of birth is required";

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!formData.contact_no) newErrors.contact_no = "Contact no required";
    if (!formData.experience_type)
      newErrors.experience_type = "Experience Type is required";
    if (formData.experience_type == "experienced") {
      if (!formData.experience_years)
        newErrors.experience_years = "Experience Years is required";
    }

    // if (!formData.living_city_id)
    //   newErrors.living_city_id = "Living city required";
    // if (!formData.nationality_id)
    //   newErrors.nationality_id = "Nationality required";

    // if (!formData.university_id)
    //   newErrors.university_id = "University required";

    // if (!formData.university_id)
    //   newErrors.university_id = "University required";

    if (!formData.degree) newErrors.degree = "Degree required";
    if (!formData.degree_id) newErrors.degree_id = "Degree required";

    if (!formData.cgpa_or_grade) {
      newErrors.cgpa_or_grade = "CGPA required";
    } else if (!cgpaRegex.test(formData.cgpa_or_grade)) {
      newErrors.cgpa_or_grade = "Enter valid number";
    }

    // if (!formData.specialization_id)
    //   newErrors.specialization_id = "Specialization required";

    if (!formData.specialization)
      newErrors.specialization = "Specialization required";

    // if (!formData.start_date) newErrors.start_date = "Start date required";

    if (!formData.end_date) {
      newErrors.end_date = "End date required";
    } else if (formData.start_date && formData.end_date < formData.start_date) {
      newErrors.end_date = "End date must be after start date";
    }

    // if (!formData.certificate_file)
    //   newErrors.certificate_file = "Upload certificate PDF";

    if (!formData.resume_file) newErrors.resume_file = "Upload resume PDF";
    // if (!formData.certificate_file)
    //   newErrors.certificate_file = "Certificate PDF";

    //Certificate

    // if (!formData.certificate)
    //   newErrors.certificate = "Certificate name required";

    // if (!formData.issuing_org) newErrors.issuing_org = "Issuing Org required";
    // if (!formData.c_main_topics)
    //   newErrors.c_main_topics = "Main Topic required";
    // if (!formData.c_start_date) newErrors.c_start_date = "Start Date required";
    // if (!formData.c_end_date) newErrors.c_end_date = "End Date required";
    // if (!formData.certificate_for_id)
    //   newErrors.certificate_for_id = "Issuing Org required";

    // if (!formData.achievement_id)
    //   newErrors.achievement_id = "Achievement id required";

    // // if (!formData.skills?.length) {
    // //   newErrors.skills = "Please select at least one skill";
    // // }

    // if (!formData.c_skills?.length) {
    //   newErrors.c_skills = "Please select at least one certificate skill";
    // }

    // // if (!formData.jobtypes?.length) {
    // //   newErrors.jobtypes = "Please select at least one Job type";
    // // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {
    if (!validate()) return;

    const formDataToSend = new FormData();
    formDataToSend.append("first_name", formData.first_name);
    formDataToSend.append("last_name", formData.last_name);
    formDataToSend.append("status", true);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("contact_no", formData.contact_no);
    formDataToSend.append("gender", formData.gender);
    formDataToSend.append("experience_type", formData.experience_type);
    formDataToSend.append("experience_years", formData.experience_years);
    formDataToSend.append("degree", formData.degree);

    formDataToSend.append("end_date", formData.end_date);
    formDataToSend.append("cgpa_or_grade", formData.cgpa_or_grade);
    formDataToSend.append("specialization", formData.specialization);
    formDataToSend.append("degree_id", formData.degree_id);
    formDataToSend.append("university_id", formData.university_id);

    // 👇 IMPORTANT — Field names must match backend
    if (formData.resume_file) {
      formDataToSend.append("resume_file", formData.resume_file);
    }

    if (formData.certificate_file) {
      formDataToSend.append("certificate_file", formData.certificate_file);
    }

    const res = await postData(`/jobseeker/signup/name`, formDataToSend);

    console.log(res, "res");

    if (res?.success) {
      setShow(true);

      setTimeout(() => {
        setShow(false);
        navigate("/");
      }, 4000);
    }
  };

  return (
    <>
      <fieldset>
        <div className="form-card StepForm">
          <div className="row step1_nameField mt-4">
            <div className="d-flex  steps-heading">
              <div className="border-left" />
              <h5>Job Seeker's Sign Up</h5>
            </div>
            <Form>
              <Row>
                <div className="col-md-6 mb-3">
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.first_name}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <Form.Label>Last Name *</Form.Label>
                  <Form.Control
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.last_name}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <Form.Label>Gender *</Form.Label>
                  <Select
                    name="gender"
                    options={genderOptions}
                    value={genderOptions.find(
                      (g) => g.value === formData.gender,
                    )}
                    onChange={(selected) =>
                      setFormData({ ...formData, gender: selected.value })
                    }
                  />
                  <span className="text-danger">{errors.gender}</span>
                </div>
                {/* <div className="col-md-6 mb-3">
                  <Form.Label>Date of Birth *</Form.Label>
                  <Form.Control
                    type="date"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.dob}</span>
                </div> */}
                <div className="col-md-6 mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.email}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <Form.Label>Contact No *</Form.Label>
                  <Form.Control
                    name="contact_no"
                    disabled
                    value={formData.contact_no}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.contact_no}</span>
                </div>
                {/* <div className="col-md-6 mb-3">
                  <Form.Label>Living City *</Form.Label>
                  <Select
                    name="living_city_id"
                    value={formData.living_city_id}
                    onChange={handleSelectChange}
                    options={cities}
                  />
                  <span className="text-danger">{errors.living_city_id}</span>
                </div> */}
                {/* Nationality */}
                {/* <div className="col-md-6 mb-3">
                  <Form.Label>Nationality *</Form.Label>
                  <Select
                    name="nationality_id"
                    value={formData.nationality_id}
                    onChange={handleSelectChange}
                    options={nations}
                  />
                  <span className="text-danger">{errors.nationality_id}</span>
                </div> */}

                <hr />
                {/* <Row> */}
                <p className="signup_labels">Higher Education : </p>
                {/* Specialization */}

                <div className="col-md-6 col-sm-12 mb-3">
                  <Form.Label>
                    University<span className="text-danger">*</span>
                  </Form.Label>
                  <div
                    className="autosuggest-container"
                    style={{ overflowY: "auto", maxHeight: "200px" }}>
                    <Autosuggest
                      className="autooooo"
                      suggestions={suggestionsList}
                      onSuggestionsFetchRequested={(request) =>
                        onSuggestionsFetchRequested(request, "university")
                      }
                      onSuggestionsClearRequested={onSuggestionsClearRequested}
                      getSuggestionValue={(suggestion) =>
                        suggestion?.name || ""
                      }
                      renderSuggestion={(suggestion) => (
                        <div>{suggestion?.name}</div>
                      )}
                      inputProps={{
                        id: "university_id",
                        value: formData?.university_id || "",
                        onChange: (event, { newValue }) => {
                          setFormData((prev) => ({
                            ...prev,
                            university_id: newValue || "",
                          }));
                        },
                        placeholder: "Enter University",
                      }}
                    />
                  </div>

                  {errors?.university_id && (
                    <span style={errorStyle}>{errors?.university_id}</span>
                  )}
                </div>
                <div className="col-md-6 col-sm-12 mb-3">
                  <Form.Label>
                    Highter Qualification{" "}
                    <span className="text-danger">*</span>{" "}
                  </Form.Label>

                  <Autosuggest
                    suggestions={suggestionsList}
                    onSuggestionsFetchRequested={(request) =>
                      onSuggestionsFetchRequested(request, "degree")
                    }
                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                    getSuggestionValue={(suggestion) => suggestion?.name || ""}
                    renderSuggestion={(suggestion) => (
                      <div>{suggestion?.name}</div>
                    )}
                    onSuggestionSelected={(event, { suggestion }) => {
                      setFormData((prev) => ({
                        ...prev,
                        degree_id: suggestion.id, // store ID
                        degree: suggestion.name, // store name
                      }));
                    }}
                    inputProps={{
                      value: formData?.degree || "",
                      onChange: (event, { newValue }) => {
                        setFormData((prev) => ({
                          ...prev,
                          degree: newValue || "",
                        }));
                      },
                      placeholder: "Enter Degree",
                    }}
                  />

                  {errors?.degree_id && (
                    <span style={errorStyle}>{errors?.degree_id}</span>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <Form.Label>Higher Qualification End Year *</Form.Label>
                  <Form.Control
                    type="text"
                    name="end_date"
                    placeholder="YYYY"
                    value={formData.end_date}
                    maxLength={4}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // only numbers
                      handleInputChange({
                        target: { name: "end_date", value },
                      });
                    }}
                  />
                  <span className="text-danger">{errors.end_date}</span>
                </div>

                <div className="col-md-6 mb-3">
                  <Form.Label>Specialization *</Form.Label>
                  <Form.Control
                    type="text"
                    name="specialization"
                    value={formData.specialization}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.specialization}</span>
                </div>

                {/* <div className="col-md-6 mb-3">
                  <Form.Label>Specialization *</Form.Label>
                  <Select
                    name="specialization_id"
                    value={formData.specialization_id}
                    onChange={handleSelectChange}
                    options={specializations}
                  />
                  <span className="text-danger">
                    {errors.specialization_id}
                  </span>
                </div> */}

                {/* <div className="col-md-6 mb-3">
                  <Form.Label>End Date *</Form.Label>
                  <Form.Control
                    type="date"
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.end_date}</span>
                </div> */}

                <div className="col-md-6 mb-3">
                  <Form.Label>CGPA *</Form.Label>
                  <Form.Control
                    name="cgpa_or_grade"
                    value={formData.cgpa_or_grade}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.cgpa_or_grade}</span>
                </div>
                {/* <div className="col-md-6 mb-3">
                  <Form.Label>Start Date *</Form.Label>
                  <Form.Control
                    type="date"
                    name="start_date"
                    value={formData.start_date}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.start_date}</span>
                </div>
                <div className="col-md-6 mb-3">
                  <Form.Label>End Date *</Form.Label>
                  <Form.Control
                    type="date"
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleInputChange}
                  />
                  <span className="text-danger">{errors.end_date}</span>
                </div> */}
                {/* <hr /> */}
                {/* <Row> */}
                {/* <p className="signup_labels">Certificate : </p> */}

                <div className="row">
                  {" "}
                  {/* <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>Certificate Name *</Form.Label>
                    <Form.Control
                      name="certificate"
                      value={formData.certificate}
                      onChange={handleInputChange}
                    />
                    <span className="text-danger">{errors.certificate}</span>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>Certificate Organization *</Form.Label>
                    <Form.Control
                      name="issuing_org"
                      value={formData.issuing_org}
                      onChange={handleInputChange}
                    />
                    <span className="text-danger">{errors.issuing_org}</span>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>Certificate Main topic *</Form.Label>
                    <Form.Control
                      name="c_main_topics"
                      value={formData.c_main_topics}
                      onChange={handleInputChange}
                    />
                    <span className="text-danger">{errors.c_main_topics}</span>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>Certificate Start Date *</Form.Label>
                    <Form.Control
                      type="date"
                      name="c_start_date"
                      value={formData.c_start_date}
                      onChange={handleInputChange}
                    />
                    <span className="text-danger">{errors.c_start_date}</span>
                  </div>{" "}
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>Certificate end Date *</Form.Label>
                    <Form.Control
                      type="date"
                      name="c_end_date"
                      value={formData.c_end_date}
                      onChange={handleInputChange}
                    />
                    <span className="text-danger">{errors.c_end_date}</span>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>certificate For *</Form.Label>
                    <Select
                      name="certificate_for_id"
                      value={formData.certificate_for_id}
                      onChange={handleSelectChange}
                      options={certificateFor}
                    />
                    <span className="text-danger">
                      {errors.certificate_for_id}
                    </span>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>certificate Achievement *</Form.Label>
                    <Select
                      name="achievement_id"
                      value={formData.achievement_id}
                      onChange={handleSelectChange}
                      options={certificateAchievement}
                    />
                    <span className="text-danger">{errors.achievement_id}</span>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <Form.Label>Skills *</Form.Label>
                    <Select
                      name="c_skills"
                      value={formData.c_skills}
                      onChange={handleSelectChange}
                      options={skills} // must be [{ value: 1, label: "React" }]
                      isMulti
                      placeholder="Select your certificate skills"
                    />
                    <span className="text-danger">{errors.c_skills}</span>
                  </div> */}
                </div>
                {/* </Row> */}

                <div className="col-md-6 mb-3"></div>
                {/* <div className="col-md-6 mb-3">
                  <Form.Label>Upload CV (PDF) *</Form.Label>
                  <Form.Control
                    type="file"
                    name="resume_file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                  />
                  <span className="text-danger">{errors.resume_file}</span>

                  {pdfPreview.resume_file && (
                    <div className="mt-3">
                      <iframe
                        src={pdfPreview.resume_file}
                        title="Resume Preview"
                        width="100%"
                        height="400px"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  )}
                </div> */}
                {/* <Row>
                  <p className="signup_labels"> Add Skills:</p>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Form.Label>Skills *</Form.Label>
                      <Select
                        name="skills"
                        value={formData.skills}
                        onChange={handleSelectChange}
                        options={skills} // must be [{ value: 1, label: "React" }]
                        isMulti
                        placeholder="Select your skills"
                      />
                      <span className="text-danger">{errors.skills}</span>
                    </div>
                  </div>
                </Row> */}
                <hr />
                {/* <Row>
                  <p className="signup_labels"> Add Job Type:</p>
                  <div className="row">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <Form.Label>job Type *</Form.Label>
                        <Select
                          name="jobtypes"
                          value={formData.jobtypes}
                          onChange={handleSelectChange}
                          options={jobType} // must be [{ value: 1, label: "React" }]
                          isMulti
                          placeholder="Select your Job Type"
                        />
                        <span className="text-danger">{errors.jobtypes}</span>
                      </div>
                    </div>
                  </div>
                </Row> */}

                <p className="signup_labels">Experience : </p>

                <Row>
                  <div className="col-md-6 mb-3">
                    <Form.Label>Experience *</Form.Label>

                    <div className="d-flex gap-4">
                      <Form.Check
                        type="radio"
                        label="Fresher"
                        name="experience_type"
                        value="fresher"
                        checked={formData.experience_type === "fresher"}
                        onChange={handleInputChange}
                      />

                      <Form.Check
                        type="radio"
                        label="Experienced"
                        name="experience_type"
                        value="experienced"
                        checked={formData.experience_type === "experienced"}
                        onChange={handleInputChange}
                      />
                    </div>

                    <span className="text-danger">
                      {errors.experience_type}
                    </span>
                  </div>

                  {formData.experience_type === "experienced" && (
                    <Row>
                      <div className="col-md-6 mb-3">
                        <Form.Label>Total Experience *</Form.Label>

                        <Form.Select
                          name="experience_years"
                          value={formData.experience_years || ""}
                          onChange={handleInputChange}>
                          <option value="">Select Experience</option>
                          <option value="0-1">0 - 1 Years</option>
                          <option value="1-2">1 - 2 Years</option>
                          <option value="2-3">2 - 3 Years</option>
                          <option value="3-5">3 - 5 Years</option>
                          <option value="5-10">5 - 10 Years</option>
                          <option value="10+">10+ Years</option>
                        </Form.Select>

                        <span className="text-danger">
                          {errors.experience_years}
                        </span>
                      </div>
                    </Row>
                  )}
                </Row>

                <hr />

                <p className="signup_labels"> Upload CV:</p>
                <div className="col-md-6 mb-3">
                  <Form.Label>Upload CV (PDF) *</Form.Label>
                  <Form.Control
                    type="file"
                    name="resume_file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                  />
                  <span className="text-danger">{errors.resume_file}</span>

                  {pdfPreview.resume_file && (
                    <div className="mt-3">
                      <iframe
                        src={pdfPreview.resume_file}
                        title="Resume Preview"
                        width="100%"
                        height="400px"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  )}
                </div>

                <p className="signup_labels"> Upload Certificate:</p>

                <div className="col-lg-6 col-md-6 mb-3">
                  <Form.Label>Upload Certificate (PDF) *</Form.Label>
                  <Form.Control
                    type="file"
                    name="certificate_file"
                    accept="application/pdf"
                    onChange={handleFileChange}
                  />
                  <span className="text-danger">{errors.certificate_file}</span>

                  {pdfPreview.certificate_file && (
                    <div className="mt-3">
                      <iframe
                        src={pdfPreview.certificate_file}
                        title="Certificate Preview"
                        width="100%"
                        height="400px"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  )}
                </div>
              </Row>
            </Form>
            {/* <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}>
              Submit
            </button> */}

            <div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </fieldset>

      {/* <div className="row mt-5  pt-4 footer-sec">
        <div className="col-md-10 col-12 desktop-view-button"></div>

        <div className="col-2">
          <div className="desktop-view-button">
            <button
              type="button"
              name="next"
              className="next action-button contin-btn"
              onClick={handleValidation}>
              Submit
            </button>
          </div>
        </div>
      </div> */}

      <div>
        <Modal
          size="md"
          show={show}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="completed-modal">
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="click text-center">
              {currentAnimation === 1 && (
                <div className="lotty-holder">
                  <Lottie
                    className="me-auto"
                    options={defaultOptionsTwo}
                    height={200}
                    width={200}
                    eventListeners={[
                      {
                        eventName: "complete",
                        callback: handleFirstAnimationFinish,
                      },
                    ]}
                  />
                  <div className="text-lottey">
                    <span>100% Completed</span>
                  </div>
                </div>
              )}
              {currentAnimation === 2 && (
                <div>
                  <Lottie
                    className="me-auto"
                    options={defaultOptionsThree}
                    height={200}
                    width={200}
                    eventListeners={[
                      {
                        eventName: "complete",
                        callback: handleCloseSecondAnimation,
                      },
                    ]}
                  />
                  <p style={{ color: "#000" }}>
                    Your Portfolio created <br></br> successfully
                  </p>
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Step1;
